import { Breadcrumb } from 'components/breadcrumb'
import EsusView from 'components/esus/EsusView'
import React from 'react'
import { useLocation } from 'react-router'

export default (props) => {
  const { search } = useLocation()

  return (
    <>
      <Breadcrumb title='Escuta inicial' />
      <EsusView url={`/pec/user/escutaInicial${search}`} />
    </>
  )
}
